export default "__VITE_ASSET__C3bU7XwU__"